import { attachDynamicEvent } from '~/common/helpers/dom'
import { processFormSubmission } from './common'

function submitIfWithFanbasis(event) {
  if (getSelectedFanbasisProcessorOption()) {
    submitWithFanbasis(event)
  }
}

async function submitWithFanbasis(event) {
  event.preventDefault()

  let submitButton = event.target
  let form = submitButton.closest('form')

  processFormSubmission(form, {
    onSuccess: (json) => {
      window.top.location.href = json.redirect
    },
    onError: (json) => {
      console.log('FanBasis submit received error: ' + JSON.stringify(json))
      alert(json.error || "We're sorry, we could not process your order.")
    },
  })
}

function getSelectedFanbasisProcessorOption() {
  return document.querySelector(
    '.cart-checkout-payment .payment-processor-option-fanbasis input[type=radio]:checked, ' +
      ".cart-checkout-payment input[type=hidden][name='payment_method'].payment-processor-option-fanbasis"
  )
}

attachDynamicEvent(
  '.cart-checkout-payment .submit-payment',
  'click',
  submitIfWithFanbasis
)
